const VariablesFilePath = "environmentVariables.json";

const getApiUrl = async () => {
  try {
    const variablesStream = await fetch(
      `${window.location.origin}/${VariablesFilePath}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    const variables = await variablesStream.json();
    const result = variables.NX_APP_API_URL;
    return result;
  } catch {
    return process.env.NX_PUBLIC_APP_LOCAL_API_URL;
  }
};

export const setRootUrl = async () => {
  if (
    process.env.NODE_ENV === "development" ||
    process.env.NODE_ENV === "test"
  ) {
    global.baseUrl =
      process.env.NX_PUBLIC_APP_LOCAL_API_URL ||
      process.env.NX_PUBLIC_APP_DEV_API_URL;
    return global.baseUrl;
  }
  global.baseUrl = await getApiUrl();
  return global.baseUrl;
};
